import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, as = "div", ...rest }) => {
    const reduce = useReducedMotion();
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            initial={reduce ? false : { opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: reduce ? 0 : delay }}
            className={className}
            {...rest}
        >
            {children}
        </MotionTag>
    );
};
